export default function Theme({ icon, style }) {
  return (
    <svg className="iconpark-icon" style={style}>
      <use href={"#" + icon}></use>
    </svg>
  );
  /*
  return (
    <svg className={"icon"} aria-hidden={"true"}>
      <use xlinkHref={`#${icon}`}></use>
    </svg>
  );
   */
}
